import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { formatPhone, toFullName } from '@/utils/stringUtils';

import { MemberRoles } from '@/components/memberActions/MemberRoles';
import { MemberStatus } from '@/components/MemberStatus';
import { UserAvatar } from '@/components/UserAvatar';

import type { TMember } from '@/types/member';

import { styles } from '../MemberModal.styles';

type TEditMemberFieldsProps = {
  member: TMember;
};

export const EditMemberFields = ({ member }: TEditMemberFieldsProps) => {
  const { t } = useTranslation();

  const name = toFullName(member);
  const phone = formatPhone(member.phone);
  const statusSince = new Date(member.statusChangedOn);

  return (
    <Box sx={styles.fields}>
      <Typography variant="h5" sx={styles.header}>
        {t('members.userForm.edit')}
      </Typography>

      <Box
        display="grid"
        gridTemplateColumns="auto 1fr"
        alignItems="center"
        marginBottom={1}
        columnGap={2}
      >
        <UserAvatar name={name} size={80} />

        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            {name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {phone}
          </Typography>
        </Box>

        <Box gridColumn="2/3">
          <MemberStatus value={member.status} since={statusSince} />
        </Box>
      </Box>

      <MemberRoles />
    </Box>
  );
};
